import { Table, Header, SpaceBetween } from "@amzn/awsui-components-react";
import { COLUMN_DEFINITIONS } from "./dlqExecutionsTableConfig";
import { DlqRedriveRequestItem } from "../hooks/useDlqRedriveData";

interface DlqExecutionsTableProps {
  items: DlqRedriveRequestItem[];
  loading: boolean;
}

export function DlqExecutionsTable({
  items,
  loading = false,
}: DlqExecutionsTableProps) {
  return (
    <Table
      resizableColumns
      stickyHeader
      columnDefinitions={COLUMN_DEFINITIONS}
      items={items}
      loading={loading}
      loadingText="Loading resources"
      selectionType="multi"
      header={
        <Header
          variant="awsui-h1-sticky"
          counter={items.length > 0 ? `(${items.length})` : undefined}
        >
          Past DLQ Redrives
        </Header>
      }
      empty={
        <SpaceBetween size="m" alignItems="center">
          <div>No executions found</div>
        </SpaceBetween>
      }
    />
  );
}
